import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "redux/store";

export const getClusterState = (state: AppState) => state.clusterList;

export const getClusterList = createSelector(getClusterState, (clusters) => {
 return clusters?.nodes;
});

export const getClusterNfs = createSelector(getClusterState, (clusters) => {
 return clusters?.nfs;
});

export const getClusterDb = createSelector(getClusterState, (clusters) => {
 return clusters?.db;
});
